// 視聴ページのステータス表示 (join フォーム下 + stage オーバーレイ)。
//
// ステータスを「i18n キー + サフィックス」で覚えておくとロケール切替時に
// 再描画できる。setFormStatus / setStageStatus は受け取った string をそのまま
// 表示し、i18n キーは記憶しない (composite で動的サフィックスが付くケース用)。
// setFormStatusKey / setStageStatusKey は key + 任意 suffix を保存し、
// rerenderStatusI18n() で再描画する。

import { t, type StringKey } from "./i18n.js";

export type FormState = "idle" | "info" | "error";
export type StageState = "connecting" | "connected" | "error";

type RememberedStatus<S> = {
  key: StringKey;
  vars: Record<string, string | number>;
  suffix: string;
  state: S;
};

let statusEl: HTMLElement;
let stageStatusEl: HTMLElement;
let lastFormStatus: RememberedStatus<FormState> | null = null;
let lastStageStatus: RememberedStatus<StageState> | null = null;

export function initStatusUi(deps: {
  statusEl: HTMLElement;
  stageStatusEl: HTMLElement;
}): void {
  statusEl = deps.statusEl;
  stageStatusEl = deps.stageStatusEl;
}

export function setFormStatus(message: string, state: FormState = "idle"): void {
  statusEl.textContent = message;
  statusEl.dataset.state = state;
  lastFormStatus = null;
}

export function setFormStatusKey(
  key: StringKey,
  state: FormState = "idle",
  vars: Record<string, string | number> = {},
  suffix = "",
): void {
  lastFormStatus = { key, vars, suffix, state };
  statusEl.textContent = t(key, vars) + suffix;
  statusEl.dataset.state = state;
}

export function setStageStatus(
  message: string,
  state: StageState = "connecting",
): void {
  stageStatusEl.textContent = message;
  stageStatusEl.dataset.state = state;
  lastStageStatus = null;
}

export function setStageStatusKey(
  key: StringKey,
  state: StageState = "connecting",
  vars: Record<string, string | number> = {},
  suffix = "",
): void {
  lastStageStatus = { key, vars, suffix, state };
  stageStatusEl.textContent = t(key, vars) + suffix;
  stageStatusEl.dataset.state = state;
}

// ロケール切替時に、記憶しておいた最後のステータスを現在ロケールで再描画する。
export function rerenderStatusI18n(): void {
  if (lastFormStatus) {
    const { key, vars, suffix, state } = lastFormStatus;
    statusEl.textContent = t(key, vars) + suffix;
    statusEl.dataset.state = state;
  }
  if (lastStageStatus) {
    const { key, vars, suffix, state } = lastStageStatus;
    stageStatusEl.textContent = t(key, vars) + suffix;
    stageStatusEl.dataset.state = state;
  }
}
